import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    rList: [],
    cList: [],
    wList: [],
    cd: 0
  }

  @action async getRoomRw() {
    let d = await http.post('/web/rank/month/group', {})
    this.data.rList = d && d.res
  }
  @action async getWealthRw() {
    let d = await http.post('/web/rank/month/wealth', {})
    this.data.wList = d && d.res
  }

  @action async getCharmRw() {
    let d = await http.post("/web/rank/month/charm")
    this.data.cList = d && d.res
  }

  @action async getCd() {
    let d = await http.post("/web/rank/month/countdown")
    this.data.cd = d && d.res
  }
}


// WEBPACK FOOTER //
// src/store/activity/monthly.js